import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { activeTab: String }

  connect() {
    this.storageKey = "admin-intake:active-tab"
    this.showTab(this.restoredTab())
    this.focusActivePanel()
  }

  switchTab(event) {
    const tabId = event.currentTarget.dataset.tabId
    this.showTab(tabId)
  }

  frameLoaded() {
    this.focusActivePanel()
  }

  clearConfirmation(event) {
    const form = event.target.closest("form")
    if (!form) return

    form.querySelectorAll("[data-admin-intake-confirm-flag]").forEach((input) => {
      input.value = "0"
    })
  }

  showTab(tabId) {
    const nextTab = tabId || "venues"
    this.activeTabValue = nextTab
    window.localStorage.setItem(this.storageKey, nextTab)

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabId === nextTab
      tab.setAttribute("aria-selected", active)
      tab.classList.toggle("bg-stone-900", active)
      tab.classList.toggle("text-white", active)
      tab.classList.toggle("shadow-sm", active)
      tab.classList.toggle("text-stone-600", !active)
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tabPanel !== nextTab)
    })
  }

  focusActivePanel() {
    const activePanel = this.panelTargets.find((panel) => panel.dataset.tabPanel === this.activeTabValue)
    if (!activePanel) return

    const focusTarget = activePanel.querySelector("[data-admin-intake-autofocus='true']")
    focusTarget?.focus()
  }

  restoredTab() {
    return this.activeTabValue || window.localStorage.getItem(this.storageKey) || "venues"
  }
}
